import {
    BACKEND
} from './local-storage.service';

export class PermissionService {
  constructor($http, LocalStorageService ) {
    this.$http = $http;
    this.host = window.HOST;
    this.defaultLang = 'en';
    this.localStorage = LocalStorageService;
  }

  load(callback) {
    return this.$http.post('/analytics/get_permissions/')
      .then(({data, status}) => {
        for (const permission in data) {
          this[permission] = data[permission];
        }
        window.BACKEND = this.getBackend(); // Used by Filter.buildQueryParams
        window.report_time_format = this.report_time_format;
        if (callback) callback();
      });
  }

  getBackend() {
    const backend = this.localStorage.getItem(BACKEND);
    if (this.backends.indexOf(backend) >= 0) return backend;
    return this.backends[0];
  }

  selectBackend( backend ) {
    this.localStorage.setItem(BACKEND, backend);
    location.reload();
  }

}



// WEBPACK FOOTER //
// ./src/core/permission.service.js